import styled from 'styled-components';

export const Wrapper = styled.header`
  min-height: 60px;
  padding: var(--gap) var(--gap) 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--gap);
`;
